export const FETCH_CAMPERS_START = 'FETCH_CAMPERS_START';
export const FETCH_CAMPERS_SUCCEEDED = 'FETCH_CAMPERS_SUCCEEDED';
export const FETCH_CAMPERS_FAILED = 'FETCH_CAMPERS_FAILED';


/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/